import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetExpensesAndIncomes(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/expensesandincomes`);
}

export function apiAddOrUpdateExpensesAndIncome(
  formData
): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateExpensesAndIncomes`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiDeleteExpensesAndIncome(id): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/expensesandincomes/${id}`);
}

export function apiGetExpenseAndIncomeDefinitions(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/expenseandincomedefinitions`);
}

export function apiAddOrUpdateExpenseAndIncomeDefinition(
  formData
): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateExpenseAndIncomeDefinition`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiDeleteExpenseAndIncomeDefinition(id): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/expenseandincomedefinitions/${id}`);
}

export function apiBookExpenseAndIncomeDefinition(id): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/bookExpenseAndIncomeDefinition/${id}`,
    null
  );
}
